import { useMemo } from 'react';
import useAppConfig from './useAppConfig';
import useChannelSource from './useChannelSource';

const useProductEnabledByChannelSource = () => {
  const { config } = useAppConfig().states;
  const { isMatchingChannelSourceAnyOf } = useChannelSource().selectors;

  const showSecondPaymentCheckBoxConfig = config.canvas?.paymentPage?.showSecondPaymentCheckBox;
  const onboardUpgradeConfig = config.productsSettings?.onboardSettings;
  const seatShopConfig = config.seatShop;

  const states = useMemo(
    () => {
      return ({
        isOnboardUpgradeEnabled:
          onboardUpgradeConfig?.enabled === true &&
          isMatchingChannelSourceAnyOf(onboardUpgradeConfig?.channelSourcesAnyOf),
        isShowSecondPaymentCheckBoxEnabled:
          showSecondPaymentCheckBoxConfig?.enabled === true &&
          isMatchingChannelSourceAnyOf(showSecondPaymentCheckBoxConfig?.channelSourcesAnyOf),
        isSeatShopEnabled:
          seatShopConfig?.enabled === true && isMatchingChannelSourceAnyOf(seatShopConfig?.channelSources),
      })
    },
    [showSecondPaymentCheckBoxConfig, onboardUpgradeConfig, seatShopConfig, isMatchingChannelSourceAnyOf],
  );

  return {
    states,
  };
};

export default useProductEnabledByChannelSource;
